import type { ChangeEvent } from 'react'
import { useSnapshot } from 'valtio'
import { state } from '@/lib/state'
import Search from '../Icons/Search'
import styles from './QueryFilter.module.css'

interface QueryFilterProps {
  value?: string
  onChange: (value: string) => void
}

export function QueryFilter({ value, onChange }: QueryFilterProps) {
  const { radarConfig } = useSnapshot(state)
  const labels = radarConfig?.labels || {}

  const _onChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value)
  }

  return (
    <div className={styles.filter}>
      <input
        className={styles.input}
        id="search"
        type="search"
        placeholder={labels.searchPlaceholder}
        value={value ?? ''}
        onChange={_onChange}
        data-testid="filter-input"
      />
      <button
        className={styles.button}
        type="submit"
        data-testid="filter-clear"
      >
        <Search className={styles.icon} />
      </button>
    </div>
  )
}
